import React from "react";
import { CalendarCheck } from "lucide-react";
import { t } from "../../utils/i18n";
import { dateActivityByKey } from "../../utils/dateActivities";

// Premier message d'une conversation créée automatiquement après acceptation d'une invitation
// de rendez-vous — une carte système centrée, visuellement distincte des bulles de chat
// classiques, jamais mêlée à une bulle "moi"/"eux". Même précédent que le journal d'appel
// (type='call'), affiché au même niveau (avant le fallback MessageBubble).
export default function DateConfirmedMessage({ lang, raw }: { lang: string; raw: string }) {
  let data: any = null;
  try { data = JSON.parse(raw); } catch { return null; }
  if (!data) return null;

  const activity = data.activity_key ? dateActivityByKey(data.activity_key) : undefined;
  const formattedDate = data.scheduled_date
    ? new Intl.DateTimeFormat(lang, { weekday: "long", day: "numeric", month: "long" }).format(new Date(`${data.scheduled_date}T00:00:00`))
    : "";

  return (
    <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
      <div style={{ maxWidth: 300, width: "100%", backgroundColor: "#fafafa", border: "1px solid #eee", borderRadius: 18, padding: 16, textAlign: "center" }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", backgroundColor: "white", border: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>
          <CalendarCheck size={17} color="#0a0a0a" />
        </div>
        <div style={{ fontSize: 13.5, fontWeight: 700, marginBottom: 8 }}>{t(lang, "date_msg_title")}</div>
        <div style={{ fontSize: 12.5, color: "#555", lineHeight: 1.6 }}>
          {activity && <div>{t(lang, activity.i18nKey)}</div>}
          {data.place_name && <div>{data.place_name}</div>}
          {formattedDate && <div>{formattedDate}{data.scheduled_time ? ` · ${data.scheduled_time}` : ""}</div>}
        </div>
        <div style={{ fontSize: 12, color: "#999", marginTop: 8 }}>{t(lang, "date_msg_footer")}</div>
      </div>
    </div>
  );
}
